export const onlineStoreList = ['Агава', 'Тандер', 'Агроторг', 'Гиперглобус', 'МВМ', 'Новацентр К',
'Сладкая Жизнь', 'УК Старт', 'Атак', 'Восторг', 'Алькор И', 'Доброцен', 'Посуда-Центр', 'Хендерсон',
'Мир Инструмента','Русмаркетцентр', 'Торгсервис', 'Агроаспект', 'Евродом', 'Стройцентр', 'Приоритетная Логистика',
'Нойтэк/Вортман']

export const networkShopsList = ['Улыбка Радуги', 'Дикси', 'Ашан', 'Бауцентр', 'Fixprice (Бэст Прайс)',
  'Верный', 'Детский Мир', 'Касторама', 'Лента', 'Ле Монлид', 'Максидом', 'Метро', 'Окей', 'Оби', 'Перекресток',
  'Эльдорадо', 'Стд Петрович', 'Читай Город', 'Кари', 'Яндекс.Лавка']